(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["designers-index"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fold(value) {
      return (value || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\u00f8/gi, 'o')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function init(root) {
      if (!root || root.dataset.designersReady) return;
      var input = root.querySelector('[data-designers-search]');
      if (!input) return;
      root.dataset.designersReady = 'true';

      var form = root.querySelector('[data-designers-search-form]');
      var empty = root.querySelector('[data-designers-empty]');
      var groups = Array.prototype.slice.call(root.querySelectorAll('.designers-index__group'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-designers-item]')).map(function (el) {
        return { el: el, text: fold(el.textContent.replace(/\(\d+\)/g, '')) };
      });
      var navLinks = Array.prototype.slice.call(root.querySelectorAll('a.designers-index__nav-link'));

      function filter() {
        var query = fold(input.value);
        var terms = query ? query.split(' ') : [];
        var visibleTotal = 0;

        items.forEach(function (item) {
          var match = terms.every(function (term) { return item.text.indexOf(term) !== -1; });
          item.el.hidden = !match;
          if (match) visibleTotal++;
        });

        var visibleGroups = {};
        groups.forEach(function (group) {
          var any = group.querySelector('[data-designers-item]:not([hidden])');
          group.hidden = !any;
          if (any) visibleGroups['#' + group.id] = true;
        });

        navLinks.forEach(function (link) {
          var on = !query || visibleGroups[link.getAttribute('href')];
          link.classList.toggle('is-empty', !on);
        });

        if (empty) empty.hidden = visibleTotal > 0;
      }

      input.addEventListener('input', filter);

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var visible = root.querySelectorAll('[data-designers-item]:not([hidden]) a');
          if (visible.length === 1) window.location.href = visible[0].href;
        });
      }

      filter();
    }

    function initAll() {
      document.querySelectorAll('[data-designers-index]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
